import React, { useState, useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { courseListRes, courseListTodo } from '../../LMS_Redux/LMS_Slices/Course/CourseList';
import { LearningTrackSchema } from './CourseManagementSchema';
import Swal from 'sweetalert2';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { Tooltip } from 'react-tooltip';
import { FaTrash } from 'react-icons/fa6';
import { addUpdateLearningTrackRes, addUpdateLearningTrackTodo } from '../../LMS_Redux/LMS_Slices/Course/AddUpdateLearningTrack';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Spinner } from 'react-bootstrap';

export default function AddLearningTrack() {

    const selectInputRef = useRef();
    const { state } = useLocation()
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const course = useSelector(state => state.courseList && state.courseList.data && state.courseList.data.data)
    const [courseId, setCourseId] = useState()
    const [courseTitle, setCourseTitle] = useState(state ? state.learning_title : '')
    const [courseDesc, setCourseDesc] = useState(state ? state.description : '')
    const [courseList, setCourseList] = useState([])
    const [oldCourse, setOldCourse] = useState([])
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    // console.log(state)

    const course_list = []

    const course_option = course && course.map((value) =>
        course_list.push({
            "value": value.id,
            "label": value.course_title,
            "code": value.course_code
        })
    )

    const filteredCourse = course_list && course_list.filter((sourceItem) =>
        !courseList.some((filterItem) => filterItem.code === sourceItem.code)
    );

    const initialValues = {
        title: courseTitle,
        description: courseDesc,
        new_course: courseList,
        track_id: state ? state.id : '',
        old_course: state ? oldCourse : []
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: LearningTrackSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateLearningTrackTodo(values)).then(() => add_update_res(action))
        },
    })

    const add_update_res = (action) => {
        if (addUpdateLearningTrackRes && addUpdateLearningTrackRes.success) {
            action.resetForm();
            toast.success(addUpdateLearningTrackRes.message, { position: "bottom-right" })
            setSpinner(false)
            setTimeout(() => {
                navigate('/learning_track')
            }, 1000);

        } else {
            toast.error(addUpdateLearningTrackRes.message, { position: "bottom-right" })
            setSpinner(false)
        }
    }

    const course_push = () => {

        // var order = document.getElementById('order')

        // if (courseId && order.value !== '') {

        //     var arr = false;
        //     for (var i = 0, len = courseList.length; i < len; i++) {

        //         if (parseInt(courseList[i].order) === parseInt(order.value)) {
        //             arr = true
        //         }

        //     }

        //     if (arr) {
        //         Swal.fire({
        //             icon: 'error',
        //             title: 'Oops...',
        //             text: "Order Already Exist!",
        //         })
        //     } else {
        //         setCourseList(courseList.concat({ "value": courseId.value, "label": courseId.label, "order": order.value, "code": courseId.code }))
        //         selectInputRef.current.clearValue()
        //         order.value = ''
        //     }

        // } else {
        //     // console.log('else', courseId)
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Oops...',
        //         text: "Select Course & It's Order!",
        //     })
        // }

        if (courseId) {
            setCourseList(courseList.concat({ "value": courseId.value, "label": courseId.label, "code": courseId.code }))
            selectInputRef.current.clearValue()
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: "Select Learning Module!",
            })
        }
    }

    // console.log(courseList)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            width: 100
        },
        {
            headerName: 'TITLE',
            field: 'label',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ID',
            field: 'code',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'ORDER',
        //     field: 'order',
        //     cellRenderer: (params) => parseInt(params.value),
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            field: 'ACTIONS',
            cellRenderer: (params) =>
                <div>
                    <FaTrash size={18} className='delete ms-3'
                        onClick={() => delete_course(params.node.rowIndex)}
                        data-tooltip-id='delete'
                        data-tooltip-content="Delete Question!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ])

    const delete_course = (index) => {
        setCourseList(oldValues => {
            return oldValues.filter((_, i) => i !== index)
        })
    }

    const course_res = () => {
        if (courseListRes && courseListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        var test = []
        var preCourse = state && state.lms_learning_courses.map((val) =>
            test.push({ "value": val.course_id, "label": val.course_title, "code": val.course_code })
        )
        setOldCourse(oldCourse.concat(test))
        setCourseList(courseList.concat(test))
        dispatch(courseListTodo({ "temp": '', "course_availability": 'public', "course_type": 'general' })).then(() => course_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Learning Module Management / </span>
                    {state ?
                        <Link to={"/learning_track"}><span className='icon2'>Learning Track / </span></Link>
                        : ''
                    }
                    <span className='icon2'>{state ? "Edit" : "Add"} Learning Track</span>
                </div>
                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <div className='wrapper-admin'>
                        <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post' >
                            <div className="row">

                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Title</label>
                                        <input type="text" className='form_input form-control' placeholder='Enter Title Name'
                                            name='title' value={values.title || ''} onChange={(e) => { handleChange(e); setCourseTitle(e.target.value) }} onBlur={handleBlur}
                                        />
                                        {errors.title && touched.title ? (<span className='text-danger form_label'>{errors.title}</span>) : null}
                                    </div>
                                </div>

                                <div className="col-12 col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Description</label>
                                        <textarea className='form_input form-control' placeholder='Enter Description Name' rows='1'
                                            name='description' value={values.description || ''} onChange={(e) => { handleChange(e); setCourseDesc(e.target.value) }} onBlur={handleBlur}
                                        />
                                        {errors.description && touched.description ? (<span className='text-danger form_label'>{errors.description}</span>) : null}
                                    </div>
                                </div>

                                <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Learning Module List</label>
                                        <Select
                                            ref={selectInputRef}
                                            closeMenuOnSelect={true}
                                            options={course_list ? filteredCourse : course_list}
                                            onChange={(option) =>
                                                setCourseId(option)
                                            }
                                            // onBlur={handleBlur}
                                            name='course_wise'
                                            // isMulti
                                            placeholder="Select Learning Module"
                                            classNamePrefix="select"
                                            id='course'
                                        />
                                        {/* {errors.course_wise && touched.course_wise ? (<span className='text-danger form_label'>{errors.course_wise}</span>) : null} */}
                                    </div>
                                </div>

                                {/* <div className="col-12 col-md-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label form_label">Order</label>
                                        <input type="number" className="form_input form-control" placeholder="Order"
                                            name='order' id='order'
                                        />
                                        {/* {errors.order && touched.order ? (<span className='text-danger form_label'>{errors.order}</span>) : null} 
                                    </div>
                                </div> */}

                                <div className="col-12 col-md-4">
                                    <div className='btn btn_submit' style={{ marginTop: '35px' }} onClick={course_push}>Add Learning Module</div>
                                </div>

                            </div>

                            {courseList &&
                                <>
                                    <DataTables
                                        rowData={courseList}
                                        columnDefs={columnDefs}
                                        height={'40vh'}
                                    />
                                    {errors.new_course && touched.new_course ? (<span className='text-danger form_label'>{errors.new_course}</span>) : null}
                                </>
                                // :
                                // <div className='text-center'>
                                //     <span className='text-danger form_label'>Please Add Learning Module</span>
                                // </div>
                            }

                            <div className='text-end mt-3'>
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }</button>
                            </div>

                        </form>
                    </div>
                }
            </div>
            <ToastContainer />
        </>
    )
}
